import { CustomTableHeader } from '../../../components/CustomTable';
import { PapelVinculosCell } from '../components/papelVinculoCell';
import { StatusVinculosCell } from '../components/statusVinculoCell';

export const valoresOffcanvas: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorTipos: '',
  separadorObservacoes: '',

  //Específicos
  status: 'Status',
  nuSolicitacao: 'Tipo de Operação',
  interface: 'Interface',
  setor: 'Setor',
  dataInicio: 'Data Início',
  dataFim: 'Data Fim',
  descricao: 'Descrição',
};
export type VinculoTableRow = {
  id: string | number;
  status: string;
  nuSolicitacao: string;
  interface: string;
  setor: string;
  dataInicio: string;
  dataFim: string;
  [key: string]: any;
};

export const renderStatusVinculos = (value: unknown) => (
  <StatusVinculosCell value={String(value)} />
);

// PapelVinculosCell
export const renderPapelVinculos = (value: unknown) => (
  <PapelVinculosCell value={String(value)} />
);

export const headersVinculo: CustomTableHeader<VinculoTableRow>[] = [
  { text: '', width: 2, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  {
    text: 'Status',
    width: 2,
    key: 'status',
    renderCell: (value) => renderStatusVinculos(value),
  },
  { text: 'Tipo de Operação', width: 14, key: 'nuSolicitacao' },
  { text: 'Interface', width: 8, key: 'interface' },
  {
    text: 'Papel',
    width: 8,
    key: 'papel',
    renderCell: (value) => renderPapelVinculos(value),
  },
  { text: 'Setor DAF, SES ou Fornecedor', width: 40, key: 'setor' },
  { text: 'Data Início', width: 15, key: 'dataInicio' },
  { text: 'Data Fim', width: 15, key: 'dataFim' },
];
